/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Journey_Link_RefusedInputs */



/**
* | output |
* | --- |
* | "This can no longer be linked: the step has a meeting by now, or the journey was stopped." |
*
* @param {Journey_Link_RefusedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const journey_link_refused = /** @type {((inputs?: Journey_Link_RefusedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Journey_Link_RefusedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Koppelen kan niet meer: deze stap heeft intussen een gesprek, of het traject is gestopt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'association n'est plus possible : cette étape a déjà un rendez-vous, ou le parcours a été arrêté.")
	return /** @type {LocalizedString} */ ("This can no longer be linked: the step has a meeting by now, or the journey was stopped.")
});